export function courseDetailsSelector(state, id) {
  return state.entities.courses[id]
}

export function courseDetailsStateSelector(state, id) {
  return state.local.courses.byId[id]
}
